'use client';

import dynamic from 'next/dynamic';

export const AiSolutionWidget = dynamic(() => import('./AiSolutionWidget'));
